import React from "react";
const __pages_import_0__ = React.lazy(() => import("/pages/example.tsx"));
import __pages_import_1__ from "/pages/index.tsx";
const __pages_import_2__ = React.lazy(() => import("/pages/testroute.tsx"));

const routes = [{"caseSensitive":false,"path":"example","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_1__)},{"caseSensitive":false,"path":"testroute","element":React.createElement(__pages_import_2__)}];

export default routes;